import e from"react";import{SvgIcon as t}from"../SvgIcon.js";const o=o=>e.createElement(t,{...o},e.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M18 4H2v2h16V4Zm0 5H2v2h16V9ZM2 14h16v2H2v-2Z"}));export{o as MenuSquared};
//# sourceMappingURL=MenuSquared.js.map
